module.exports = __webpack_public_path__ + "img/00047.e6f6fa23.webp";